import { Component, Input, OnInit } from '@angular/core';
import { CustomerPortalUser } from '../../../client/repositories/user/models/user.model';
import { UserMessage } from '../../../client/repositories/user-message/models/user-message.model';

@Component({
  selector: 'app-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
})
export class MessageContainerComponent implements OnInit {
  @Input() message!: UserMessage;
  @Input() user?: CustomerPortalUser;
  @Input() currentUser = true;

  ngOnInit(): void {}
}
